export const CONTRACT_USAGE_CARD_OPTIONS = [
  "Current contract usage",
  "Last year contract usage",
  "2 Years Ago",
];
